import { Component, ElementRef, EventEmitter, inject, Input, Output, ViewChild,
    ChangeDetectionStrategy
} from '@angular/core';
import { GuiUtils } from 'src/modules/utils/misc/gui-utils';
import { GradeType } from '../../shared/grade-type.enum';
import { ExamGrade } from '../../shared/exam-grade.entity';
import { ConductGrade } from '../../shared/conduct-grade.entity';
import { FrontendForm } from 'src/modules/sm-base/netgen/FrontendForm';
import { FrontendField } from 'src/modules/sm-base/netgen/FrontendField';
import { FrontendFieldType } from 'src/modules/sm-base/netgen/FrontendFieldType';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { Utils } from 'src/modules/utils/shared/utils';
import { SmTableCellEditorComponent } from 'src/modules/sm-base/components/sm-table-cell-editor/sm-table-cell-editor.component';

@Component({
    selector: 'sm-grade-editor',
    templateUrl: './grade-editor.component.html',
    styleUrls: ['./grade-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GradeEditorComponent {
     
    _GuiUtils = GuiUtils;
    _GradeType = GradeType;

    app = inject(MainAppService);

    @Input()
    gradeType = GradeType.percent;
    
    tableCellEditor: SmTableCellEditorComponent;

    _value: ExamGrade | ConductGrade | number = null;
    grade: any = "";
    isExamGrade = false;
    @Output() valueChange = new EventEmitter<ExamGrade | ConductGrade | number>();

    @ViewChild('inputRef', { static: true}) inputRef!: ElementRef;

    ngDoCheck(): void {
        //Das benötigen wir, weil jedes Mal, wenn in einer Tabelle ArrowDown/Up gedrückt wird um zur nächsten Zelle zu gelangen,
        //wird spin aufgerufen und bei leerer Eingabe der Wert 0 gesetzt, was nicht sein soll.
        if (this.inputRef != null) {
           (this.inputRef as any).spin = () => {
           };
        }       
    }
  
    @Input()
    set value(value: ExamGrade | ConductGrade | number) {
        this._value = value;
        this.grade = this._value == null || Utils.isNumber(this._value)? (this._value as number)
                : (this._value as ExamGrade | ConductGrade).grade >= 0 && (this._value as ExamGrade | ConductGrade).grade <= 999 ? (this._value as ExamGrade | ConductGrade).grade : null;
        this.isExamGrade = this._value instanceof ExamGrade;
    }

    focus(event: any): void {
        GuiUtils.selectAll(event);    
    }
          
    change(): void {       
        let grade = Utils.toNumber(this.grade, false, false, -1);
        if (this._value == null || Utils.isNumber(this._value)) {
            this._value = grade;
        }
        else {
            (this._value as ExamGrade | ConductGrade).grade = grade;
        }
        this.valueChange.emit(this._value);
    }

    async editGrade(event: any, grade: ExamGrade | ConductGrade | number): Promise<void> {
        let editedGrade = grade;
        let editGradeForm = new FrontendForm([
            new FrontendField("title", "Thema (abweichend)", FrontendFieldType.string),
            new FrontendField("date", "Datum (abweichend)", FrontendFieldType.date)
        ]);
        editGradeForm.fill(grade);
        if (await this.app.dialog.form(editGradeForm, "Note bearbeiten", [this.app.dialog.save, this.app.dialog.cancel]) == "save") {
            editGradeForm.get(editedGrade);
          //  this.gradeUpdated();
        }
    }

    keyDown(event: KeyboardEvent): void {
        if (this.tableCellEditor != null) {
            if (event.key == "ArrowDown") {
                this.change();
                this.tableCellEditor.params.api.stopEditing();
                this.tableCellEditor.params.api.tabToNextCell();
                this.tableCellEditor.params.api.startEditingCell({
                    rowIndex: this.tableCellEditor.params.api.getFocusedCell().rowIndex,
                    colKey: this.tableCellEditor.params.api.getFocusedCell().column.getColId()
                });                
            }
            else if (event.key == "ArrowUp") {
                this.change();
                this.tableCellEditor.params.api.stopEditing();
                this.tableCellEditor.params.api.tabToPreviousCell();
                this.tableCellEditor.params.api.startEditingCell({
                    rowIndex: this.tableCellEditor.params.api.getFocusedCell().rowIndex,
                    colKey: this.tableCellEditor.params.api.getFocusedCell().column.getColId()
                });
                
            }
        }
    }

    setContext(context: any): void {
    }
}
